<template>

    <v-speed-dial v-if="shown" location="top center" :close-on-content-click="false">
        <template v-slot:activator="{ props: activatorProps }">
            <v-fab class="position-absolute" style="right:20px;bottom:20px;" v-bind="activatorProps" size="large"
                icon="mdi-menu" />
        </template>

        <v-tooltip text="Refresh the app" location="left">
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" key="1" icon="mdi-refresh" :loading="refreshBtn.loading"
                    :disabled="refreshBtn.loading" @click="refresh" />
            </template>
        </v-tooltip>

        <v-tooltip text="Pair a new screen" location="left">
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" key="2" icon="mdi-delete" :loading="pairNewBtn.loading"
                    :disabled="pairNewBtn.loading" @click="pairNew" />
            </template>
        </v-tooltip>

        <v-tooltip text="Logout" location="left">
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" key="3" icon="mdi-logout" :loading="logoutBtn.loading"
                    :disabled="logoutBtn.loading" @click="logout" />
            </template>
        </v-tooltip>

    </v-speed-dial>

</template>

<script>

export default {
    name: 'MainSpeedDial',
    data() {
        return {
            logoutBtn: {
                loading: false,
            },
            pairNewBtn: {
                loading: false,
            },
            refreshBtn: {
                loading: false,
            },
        }
    },
    props: {
        shown: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        logout() {
            this.logoutBtn.loading = true;

            this.$auth0.logout({ logoutParams: { returnTo: window.location.origin } });
        },
        pairNew() {
            this.pairNewBtn.loading = true;

            //Load the pairing view which removes the pairing code
            this.$router.push({ name: 'pairing' });
        },
        refresh() {
            this.refreshBtn.loading = true;

            window.location.reload();
        },
    },
}
</script>